export enum Actions {
  GET_THEME = 'GET_THEME',
  SET_THEME = 'SET_THEME',
  EDIT_THEME = 'EDIT_THEME',
}

export interface ITheme {
  border_radius: number
  primary_color: string
  // Drives borders, dividers, and disabled buttons. Surfaced in the editor as
  // "Border color" (VERA-269); the data key stays `secondary_color` so stored
  // company styles and the app palette keep working without a migration.
  secondary_color: string
  // Body / paragraph text color (VERA-269). Headings use `primary_color`.
  text_color: string
  bg_color: string
  // Body / paragraph font. (Kept as `font` for back-compat — surfaced as
  // "Body font" in the editor, VERA-270.)
  font: string
  // Heading / title font (VERA-270). Falls back to `font` when unset.
  title_font: string
  // Email header logo placement (VERA-270). Email-only; defaults left / medium.
  logo_align: 'left' | 'center' | 'right'
  logo_size: 'small' | 'medium' | 'large'
  // Which brand asset (mark vs wordmark) each surface uses (VERA-267). Per-surface
  // so a brand can show the wordmark in emails and the mark on certificates, etc.
  // Defaults to 'mark' (the only asset persisted today — wordmark storage is VRG-18).
  email_logo_variant: 'mark' | 'wordmark'
  certificate_logo_variant: 'mark' | 'wordmark'
  /**
   * VERA-304 — READ-ONLY here. The brand's own mark, merged into this payload
   * server-side from `companies.logo`; it is NOT stored in
   * `companies_settings.styles` and Studio must never write it back (the save
   * whitelist in StudioPage's `onSubmit` deliberately omits it). Present only
   * when the company has a logo set.
   */
  logo?: string
}
